import type React from "react";
import { cn } from "../utils/cn";

interface InsightsIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  title?: string;
  dark?: boolean;
}

export function InsightsIcon({ className, title = "Insights Icon", dark, ...props }: InsightsIconProps) {
  // Ensure title is never empty for accessibility
  const accessibleTitle = title || "Insights Icon";

  return (
    <svg
      className={cn(className)}
      aria-label={accessibleTitle}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{accessibleTitle}</title>
      <mask id="path-1-inside-1_9213_67295" fill="white">
        <rect x="2" y="2" width="16" height="16" rx="1" />
      </mask>
      <rect
        x="2"
        y="2"
        width="16"
        height="16"
        rx="1"
        stroke={dark ? "white" : "black"}
        stroke-width="3.4"
        mask="url(#path-1-inside-1_9213_67295)"
      />
      <line x1="10.85" y1="3" x2="10.85" y2="17" stroke={dark ? "white" : "black"} stroke-width="1.7" />
      <line x1="11" y1="9.15" x2="17" y2="9.15" stroke={dark ? "white" : "black"} stroke-width="1.7" />
    </svg>
  );
}

export default InsightsIcon;
